<template>
  <p-form-element class="p-lookup">
    <p-select
      v-bind="$props"
      :can-search="true"
      :search="search"
      :perform-local-search="false"
      :items="internalItems"
      :context-icon="computedContextIcon"
      v-on="$listeners"
      @focus="onFocus"
      @update:search="$emit('update:search', $event)"
    >
      <template #prepend-list>
        <p-container v-if="!search && internalItems.length === 0" fluid>
          <slot name="search-prompt">
            <span class="caption-1">
              {{ $t('core.PLookup.searchPrompt') }}
            </span>
          </slot>
        </p-container>
        <p-container v-if="search && internalItems.length === 0" fluid>
          <slot name="no-results">
            <span class="caption-1">
              {{ $t('core.PLookup.noResults') }}
            </span>
          </slot>
        </p-container>
      </template>
    </p-select>
  </p-form-element>
</template>

<script lang="ts">
  import PSelect from '../p-select/p-select.vue';
  import colorable from '../../mixins/colorable/colorable';
  import interactable from '../../mixins/interactable/interactable';
  import mixins from '../../mixins';

  export default mixins(colorable, interactable).extend({
    mixins: [colorable, interactable],
    props: {
      ...((new PSelect()).$options.props),
    },
    data: () => ({
      internalItems: [],
    }),
    computed: {
      computedContextIcon(): string {
        return (this.contextIcon as string) ?? 'search';
      },
    },
    watch: {
      items() {
        this.internalItems = this.items;
      },
    },
    methods: {
      onFocus() {
        (this as any).internalItems = [];
      },
    },
  });
</script>
